const button = (botIndex, content) => `<button class="btn" type="button" data-bot-index="${botIndex}">${content}</button>`;

export default button;
